// extracted by mini-css-extract-plugin
export default {"dropdown-selector":"LangPicker_dropdown-selector__b2Mku"};